import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import BonusListItemDataProp, {
  BonusListItemBlock,
} from '../../propTypes/bonusListItemDataProp';
import BonusListDataItemBlock from './BonusListDataItemBlock';

function BonusListData(props) {
  const { t, listData, handleClickSeeAll } = props;

  const renderListItems = blockType => {
    const itemsInType = listData.filter(item => item.block === blockType);

    if (itemsInType.length === 0) return null;

    return (
      <BonusListDataItemBlock
        t={t}
        items={itemsInType}
        blockType={blockType}
        onClickSeeAll={handleClickSeeAll}
      />
    );
  };

  return (
    <>
      {listData.length > 0 && (
        <>
          {renderListItems(BonusListItemBlock.STARTING_BONUS)}
          {renderListItems(BonusListItemBlock.JACKPOT)}
          {renderListItems(BonusListItemBlock.DESTINATION)}
        </>
      )}
    </>
  );
}

export default translate(BonusListData);

BonusListData.propTypes = {
  t: PropTypes.func.isRequired,
  listData: PropTypes.arrayOf(PropTypes.shape(BonusListItemDataProp.propType))
    .isRequired,
  handleClickSeeAll: PropTypes.func.isRequired,
};
